import encryptedStorage from '@storage/encryptedStorage';
import { generateUUID } from '@utils/uuid';

const DEVICE_ID_KEY = 'ds_merchant_device_id';

export const getMerchantDeviceId = () => {
  const existing = encryptedStorage.getItem(DEVICE_ID_KEY);
  if (existing) return String(existing);

  const deviceId = generateUUID();
  encryptedStorage.setItem(DEVICE_ID_KEY, deviceId);
  return deviceId;
};

const getOrCreateDeviceId = getMerchantDeviceId;

export const getOsLabel = () => {
  if (typeof navigator === 'undefined') return 'Web';

  const platform = navigator.userAgentData?.platform || navigator.platform || 'Web';
  return String(platform);
};

const getCurrentPosition = () =>
  new Promise((resolve) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      resolve({ latitude: '', longitude: '' });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: String(position.coords.latitude),
          longitude: String(position.coords.longitude),
        });
      },
      () => resolve({ latitude: '', longitude: '' }),
      { enableHighAccuracy: false, timeout: 5000, maximumAge: 60000 },
    );
  });

export const getMerchantDeviceHeaders = async () => {
  const { latitude, longitude } = await getCurrentPosition();

  return {
    'X-Device-Id': getOrCreateDeviceId(),
    'X-Device-Type': 'WEB',
    'X-OS': getOsLabel(),
    'X-Latitude': latitude,
    'X-Longitude': longitude,
    'X-Current-Latitude': latitude,
    'X-Current-Longitude': longitude,
  };
};

export default getMerchantDeviceHeaders;
